import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { create } from 'jss';
import preset from 'jss-preset-default';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import { appState } from './store';
import ThemeProvider from './components/theming/ThemeProvider';
import { initializeErrorReporter } from './libs/helpers/utils';
import { BASE_PATH, IS_PRODUCTION, SENTRY_CONFIG } from './libs/constants';
const jss = create();
jss.setup(preset());
IS_PRODUCTION && initializeErrorReporter(SENTRY_CONFIG);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            cacheTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
        },
    },
});
const root = createRoot(document.getElementById('cherehapa-root'));
root.render(_jsx(Provider, { store: appState, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(ThemeProvider, { children: _jsxs(Router, { basename: BASE_PATH, children: [_jsx(App, {}), _jsx("div", { style: { height: 0 }, "data-iframe-height": true })] }) }) }) }));
